import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { usePlaceholderFilter } from "@/components/refine-ui/data-table/use-placeholder-filter";
import { Checkbox } from "@/components/ui/checkbox";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useVenueColumns } from "@/pages/venues/hooks/use-columns";
import { IVenueData } from "@/types/venue";

export const VenuesList = () => {
  const columns = useVenueColumns();

  const defaultQueryBy =
    "enrichment.transliterations.el,enrichment.transliterations.en,name";

  const table = useTable<IVenueData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: {
        right: ["actions"],
      },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: defaultQueryBy,
      },
      sorters: {
        initial: [
          {
            field: "createdAt",
            order: "desc",
          },
        ],
      },
      pagination: {
        pageSize: 25,
      },
    },
    meta: {
      querySuggestions: [
        {
          id: "slug",
          label: "slug",
        },
        {
          id: "type",
          label: "type",
        },
        {
          id: "geodata.name",
          label: "city",
        },
        {
          id: "geodata.country",
          label: "country",
        },
        {
          id: "status",
          label: "status",
        },
      ],
    },
  });

  const placeholder = usePlaceholderFilter(table);

  return (
    <ListView>
      <DataTableActionBar resource="venues" table={table}>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="placeholder-art"
            defaultChecked={placeholder.isApplied}
            onCheckedChange={placeholder.toggle}
          />
          <label
            htmlFor="placeholder-art"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Placeholder Image
          </label>
        </div>
      </DataTableActionBar>
      <DataTable table={table} />
    </ListView>
  );
};
